






































import { DashboardVendedorRankingItem } from "@/services/dashboard-vendedor.service";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class WidgetRankingVendedores extends Vue {
  @Prop({ required: true }) readonly ranking!: DashboardVendedorRankingItem[];
  @Prop({ required: true }) readonly idUsuarioAtual!: number;
  @Prop({ required: true }) readonly idVendedorSelecionado!: number;
  @Prop({ default: false }) readonly isAdmin!: boolean;

  isUsuarioAtual(idUsuario: number): boolean {
    return this.idUsuarioAtual === idUsuario;
  }

  isVendedorSelecionado(idUsuario: number): boolean {
    return this.idVendedorSelecionado === idUsuario;
  }

  selecionarVendedor(idUsuario: number): void {
    this.$emit("selecionar-vendedor", idUsuario);
  }

  avatarLabel(item: DashboardVendedorRankingItem): string {
    if (item.posicao === 1) {
      return "🥇";
    }

    if (item.posicao === 2) {
      return "🥈";
    }

    if (item.posicao === 3) {
      return "🥉";
    }

    return this.initials(item.nome);
  }

  isMedalha(item: DashboardVendedorRankingItem): boolean {
    return item.posicao >= 1 && item.posicao <= 3;
  }

  initials(nome: string): string {
    const parts = nome.split(" ").filter((item) => !!item);
    if (!parts.length) {
      return "--";
    }

    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
}
